import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import React, { ReactNode, useMemo } from 'react';
import { findAttribute, findAttributeValue } from '../../../../common/utilities/productListExtensionHelpers';

const HideablePrice = ({
    attributeValues,
    price,
    seePriceInCartLabel
}: {
    attributeValues?: AttributeValue[];
    price: ReactNode;
    seePriceInCartLabel: string;
}) => {
    const hidePrice = useMemo(() => {
        if (attributeValues) {
            const hidePriceAttribute = findAttribute(attributeValues, 'See Price In Cart');
            if (hidePriceAttribute) {
                const hidePriceValue = findAttributeValue(hidePriceAttribute);
                if (typeof hidePriceValue === 'boolean' && hidePriceValue) {
                    return hidePriceValue;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }

        return null;
    }, [attributeValues]);

    if (hidePrice == null) {
        return null;
    }

    return hidePrice ? <p className={'hide-price hide-price--detail'}>{seePriceInCartLabel}</p> : <>{price}</>;
};

export { HideablePrice };
